import { useMsal } from '@azure/msal-react';
import type { ReactNode } from 'react';
import { config } from './config';

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'U';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Signed-in user's circle + sign-out, shown top-right in the app bar. */
function UserMenu() {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const name = account?.name ?? account?.username ?? 'User';
  return (
    <div className="usermenu">
      <span className="username" title={account?.username ?? ''}>{name}</span>
      <span className="avatar" aria-hidden="true">{initialsOf(name)}</span>
      <button
        className="signout"
        onClick={() => void instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin })}
      >
        Sign out
      </button>
    </div>
  );
}

/** App shell: left navigation menu + top bar (user circle / sign-out on the right). */
export function AppShell({ children }: { children: ReactNode }) {
  // "Forms" returns to the management console's form list (falls back to same-origin).
  const formsHref = config.managementUrl || '/';
  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">Forms</div>
        <nav className="nav">
          <a className="nav-item" href={formsHref}>Forms Admin</a>
        </nav>
      </aside>
      <div className="main">
        <header className="topbar">
          <UserMenu />
        </header>
        <main className="content">{children}</main>
      </div>
    </div>
  );
}
